import React from 'react';
import MaterialTable from 'material-table';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { colors } from 'kangarootime-ui';

const DEFAULT_HEADER_STYLES = { fontSize: 14 };
const DEFAULT_CELL_STYLES = { fontSize: 14 };

// wrapper around the `MaterialTable` component to provide consistent styling and theming
const DataTable = props => {
  // make a copy of `props` since `props` is immutable BUT we need to modify some props to apply the default styling
  const propsCopy = { ...props };

  const theme = createMuiTheme({
    palette: {
      secondary: {
        main: colors.brand_3
      }
    }
  });

  // add default styling to cells
  if (props.columns !== undefined) {
    propsCopy.columns = propsCopy.columns.map(column => ({
      ...column,
      cellStyle: DEFAULT_CELL_STYLES,
      headerStyle: DEFAULT_HEADER_STYLES
    }));
  }

  // set default number of visible rows to 10, hide any extra rows
  propsCopy.options = {
    ...propsCopy.options,
    pageSize: 10,
    emptyRowsWhenPaging: false,
    actionsColumnIndex: -1
  };

  return (
    <MuiThemeProvider theme={theme}>
      <MaterialTable {...propsCopy} />
    </MuiThemeProvider>
  );
};

export default DataTable;
